<template>

    <div class="input-group | vn-input-dropdown" :class="cssInputClass">

        <label :for="instanceId" v-html="field.title"></label>
        <select
            data-form
            :name="key"
            :id="instanceId"
            v-model="value"
            @change="clearError"
            ref="selectField"
        >
            <option v-for="option in options"
                    :id="option.id"
                    :value="option.value"
            >{{ option.text }}
            </option>

        </select>

        <span class="error-message" v-if="gotError"> {{ errorMessage }} </span>
    </div>

</template>

<script>

export default {
    name : "InputDropdown",
}

</script>

<script setup>

import { computed, onMounted, ref } from "vue";
import useFormInput                 from "../../composables/useFormInput";
import { uniqueId }                              from 'lodash-es';

let props = defineProps( [ "field" ] );

let options = computed( () => props.field.value_list.map( v => ({ id : v.key, text : v.label, value: v.value && v.value !== '' ? v.value : v.label }) ) );

let { gotError, clearError, cssInputClass, errorMessage, value, key, exposed, setValue } = useFormInput( props );

defineExpose( exposed );

let selectField = ref( null );
let instanceId = ref( null );

let boundResize = ref(null);

function mounted ()
{

    let selectOptions = {
        minimumResultsForSearch : Infinity,
        placeholder             : props.field.title.value,
        width                   : 'resolve',
    };


    if ( instanceId.value === null )
    {
        instanceId.value = uniqueId(  props.field.key + '_' );
    }

    const $sel     = $( selectField.value  );
    const $parent  = $sel.parent();


    selectOptions.dropdownParent = $parent;


    selectField.value.style.width = (selectField.value.clientWidth + 30) + "px";

    if(!boundResize.value) {
        window.addEventListener('resize', () => {
            selectField.value.style.width = (selectField.value.clientWidth + 30) + "px";
        })
    }

    setTimeout( () =>
    {

        console.log('Going to setup Select2 on  #' + instanceId.value ,  $sel  )
        $sel
            .select2( selectOptions )
            .on( 'change.select2', ( e ) =>
            {

                // console.log("INSIDE KEY",  e)
                //
                // let key = fieldKey;
                // // let value = e.currentTarget.value

                // emits( 'update', { key, value } );
               clearError();


                setValue( $sel.val() );

            } );

    }, 100 );
}

onMounted( mounted );
</script>
